// Enregistrement automatique d'une valeur éditée (jours, types d'accès…) : dès que `value` diffère
// de `saved` (la valeur connue du serveur), on attend `delay` ms sans nouvelle modification puis on
// appelle `save(value)`. Aucune nouvelle tentative tant que `value` ne change pas : une erreur (ex.
// 409 « type encore utilisé ») ne boucle donc pas ; `onError` permet au parent de remettre la valeur.
import { useEffect, useRef, useState } from 'react';

export const useAutosave = ({ value, saved, save, onError, delay = 800 }) => {
  const [status, setStatus] = useState('idle'); // idle | saving | saved | error
  const [error, setError] = useState('');
  // Dernières fonctions du parent, sans relancer le minuteur à chaque rendu.
  const latest = useRef({ save, onError });
  latest.current = { save, onError };

  const valueJson = JSON.stringify(value);
  const savedJson = JSON.stringify(saved);

  useEffect(() => {
    // `saved` indéfini = session pas encore chargée : rien à enregistrer.
    if (saved === undefined || valueJson === savedJson) return undefined;
    const timer = setTimeout(async () => {
      setStatus('saving');
      setError('');
      try {
        await latest.current.save(JSON.parse(valueJson));
        setStatus('saved');
      } catch (err) {
        setStatus('error');
        setError(err?.response?.data?.error || "L'enregistrement a échoué.");
        latest.current.onError?.(err);
      }
    }, delay);
    return () => clearTimeout(timer);
  }, [valueJson, savedJson, saved, delay]);

  return { status, error };
};

export default useAutosave;
